import { defineStore, getActivePinia } from 'pinia'

import type { GaApp } from '~/modules/app'

import { state } from './state'

export const ratingStore = (gaApp: GaApp) => {
  const init = defineStore('rating', {
    state,
  })

  return init(getActivePinia())
}
